import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';

function ServiceOptionToolTipModal({
  show,
  handleClose,
  link
}: {
  show: boolean,
  handleClose: () => void,
  link: string
}) {

  return (
    <Modal show={show} onHide={handleClose} size='lg'>
      <Modal.Header closeButton style={{ borderBottom: 'none' }}></Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col className='mb-4'>
              <iframe className='w-100' height='350' src={link} title="Comporium"></iframe>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
}

export default ServiceOptionToolTipModal;